module.exports = __webpack_public_path__ + "static/media/arrow_right.2aca49ad.svg";